import { useDynamicConfig } from '@statsig/react-bindings';

import { EventType } from '@/analytics/types';

import { NewYearHeroBackground } from './common/NewYearHeroBackground';
import type { DiscountDifferenceData } from './HolidayHeroTemplate25';
import SDBFCMHeroTemplate2025 from './HolidayHeroTemplate25';

const BoxingDayHero = () => {
  const discountDifferenceData = useDynamicConfig(
    'boxing_day_winter_sale_hero_title_price',
  ).value;

  return (
    <SDBFCMHeroTemplate2025
      Background={NewYearHeroBackground}
      discountDifferenceData={
        discountDifferenceData as unknown as DiscountDifferenceData
      }
      tagMsgKey="boxing_day_sale"
      titleMsgKey="holiday_hero_title_2025"
      subcopyMsgKey="boxing_day_copy_2025"
      buttonProps={{
        href: '/store',
        ctaLabel: 'shop_sale',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop sale',
            action: 'go to store',
            location: 'hero',
            path: '/store',
          });
        },
      }}
    />
  );
};

export default BoxingDayHero;
